<template>
  <div>
    <NavSection/>
    <section>
      <div class="portal-top-div">
        <div class="w-layout-blockcontainer portal-tab-container w-container">
          <div class="text-block-914">Hi, {{first_name}}</div>
          <div data-current="Tab 1" data-easing="ease" data-duration-in="300" data-duration-out="100" class="tabs w-tabs">
            <div class="tabs-menu">
              <a data-w-tab="Tab 1" class="portal-tab w-inline-block w-tab-link" @click.prevent="switchTab('orders')" :class="currentTab === 'orders'? 'w--current' : ''">
                <div class="text-block-927">Orders</div>
              </a>
              <a data-w-tab="Tab 6" v-if="user.health_id" class="portal-tab w-inline-block w-tab-link" @click.prevent="switchTab('doctorOnDemand')"  :class="currentTab === 'doctorOnDemand'? 'w--current' : ''">
                <div class="text-block-927">Doctor on Demand</div>
              </a>

              <a data-w-tab="Tab 5" v-if="hasPrescription" class="portal-tab w-inline-block w-tab-link" @click.prevent="switchTab('dosage')"  :class="currentTab === 'dosage'? 'w--current' : ''">
                <div class="text-block-927">Dosage</div>
              </a>
              <a data-w-tab="Tab 2" class="portal-tab w-inline-block w-tab-link" @click.prevent="switchTab('profile')" :class="currentTab === 'profile'? 'w--current' : ''">
                <div class="text-block-927">Profile</div>
              </a>
              <a data-w-tab="Tab 3" class="portal-tab w-inline-block w-tab-link" @click.prevent="switchTab('billing')" :class="currentTab === 'billing'? 'w--current' : ''">
                <div class="text-block-927">Billing</div>
              </a>
            </div>
            <div class="w-tab-content">
              <div data-w-tab="Tab 1" class="w-tab-pane" v-show="currentTab === 'orders'" :class="currentTab === 'orders'? 'w--tab-active' : ''">
                <myNewSelfSection :user="user" :baseUrl="baseUrl"></myNewSelfSection>
              </div>
              <div data-w-tab="Tab 2" class="w-tab-pane" v-show="currentTab === 'profile'" :class="currentTab === 'profile'? 'w--tab-active' : ''">
                <ProfileSection :user="user" :baseUrl="baseUrl"></ProfileSection>
              </div>
              <div data-w-tab="Tab 3" class="w-tab-pane" v-show="currentTab === 'billing'"  :class="currentTab === 'billing'? 'w--tab-active' : ''">
                <OrderInfoSection :user="user" :baseUrl="baseUrl"></OrderInfoSection>
              </div>
              
              <div data-w-tab="Tab 5" class="w-tab-pane" v-show="currentTab === 'dosage'"  :class="currentTab === 'dosage'? 'w--tab-active' : ''">
                <prescriptionShow :user="user" :baseUrl="baseUrl"></prescriptionShow>
              </div>
              <div data-w-tab="Tab 6" class="w-tab-pane" v-show="currentTab === 'doctorOnDemand'"  :class="currentTab === 'doctorOnDemand'? 'w--tab-active' : ''">
                <talkToDocWindow :user="user" :baseUrl="baseUrl"></talkToDocWindow>
              </div>
              <div data-w-tab="Tab 7" class="w-tab-pane">
                <div class="portal-tab-div">
                  <div class="div-block-2089">
                    <div class="text-block-1409">STOCK UP BEFORE FDA CRACKDOWN</div>
                    <div class="text-block-1415">LOCK IN TIRZEPATIDE<br>FOR 12 MONTHS</div>
                    <p class="paragraph-175">The landscape for compound Tirzepatide is changing. We are not sure what the future holds...however we can offer any current patient who renew access for the next 12 months. Choose a 3 or 6 month plan below to extend. </p>
                    <div class="bullets-timer-div">
                      <div class="portal-bullets-div">
                        <div class="div-block-2088"><img loading="lazy" src="@/assets/images/icon_check_lime.svg" alt="" class="image-562">
                          <div class="text-block-1418">Extend current prrecription for 12 months.</div>
                        </div>
                        <div class="div-block-2088"><img loading="lazy" src="@/assets/images/icon_check_lime.svg" alt="" class="image-562">
                          <div class="text-block-1418">Revisit with doctor for new prescription.</div>
                        </div>
                        <div class="div-block-2088"><img loading="lazy" src="@/assets/images/icon_check_lime.svg" alt="" class="image-562">
                          <div class="text-block-1418">Requires Doctor Check In every 90 Days.</div>
                        </div>
                      </div>
                      <div class="div-block-2090">
                        <div class="countdown-main-div-2">
                          <div class="countdown-header-div-2">
                            <div class="text-block-1411"><strong class="bold-text-30">TIRZEPATIDE SALES END IN:</strong><br></div>
                          </div>
                          <div class="countdown-row-2">
                            <div class="countdown-block">
                              <div id="days" class="countdown-time-2">00</div>
                              <div class="countdown-detail-2">- Days -</div>
                            </div>
                            <div class="countdown-block">
                              <div id="hours" class="countdown-time-2">00</div>
                              <div class="countdown-detail-2">- Hours -</div>
                            </div>
                            <div class="countdown-block">
                              <div id="minutes" class="countdown-time-2">00</div>
                              <div class="countdown-detail-2">- Minutes -</div>
                            </div>
                            <div class="countdown-block">
                              <div id="seconds" class="countdown-time-2">00</div>
                              <div class="countdown-detail-2">- Seconds -</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="_3-products-div">
                    <div class="portal-product-box">
                      <div class="ppb_imgdiv">
                        <img loading="lazy" src="@/assets/images/Tirzepatide-Vial.png" alt="" class="image-560">
                        <img loading="lazy" src="@/assets/images/Tirzepatide-Vial.png" alt="" class="image-561">
                      </div>
                      <div class="ppb_infodiv">
                        <div class="ppb_name-price">
                          <div class="ppb_name">
                            <div class="text-block-1420">3 Month Plan<br></div>
                            <div class="text-block-1410">Lock in 12 months of refills</div>
                          </div>
                          <div class="pbb_price">
                            <div class="pbb_priceflex">
                              <div class="text-block-1416">$</div>
                              <div class="text-block-1413">749</div>
                              <div class="text-block-1416">.97</div>
                            </div>
                            <div class="text-block-1412">$249.99/mo.</div>
                          </div>
                        </div>
                        <p class="paragraph-174">Pay up front for <strong>3 months</strong> and receive 12 months of refills.</p>
                        <ul role="list" class="list-5">
                          <li class="list-item-11">
                            <div class="text-block-1419">All Dosages Same Price.</div>
                          </li>
                          <li class="list-item-11">
                            <div class="text-block-1419">Doctor Visit Included.</div>
                          </li>
                          <li class="list-item-11">
                            <div class="text-block-1419">12 Months of Refills (provided ONLY by our pharmacy partner and after doctor checkin)</div>
                          </li>
                        </ul>
                      </div>
                      <div class="ppb_timer-buttondiv">
                        <a href="#" class="button-135 w-button">BUY NOW!</a>
                      </div>
                    </div>
                    <div class="portal-product-box _2">
                      <div class="ppb_imgdiv">
                        <img loading="lazy" src="@/assets/images/Tirzepatide-Vial.png" alt="" class="image-560">
                        <img loading="lazy" src="@/assets/images/Tirzepatide-Vial.png" alt="" class="image-561">
                      </div>
                      <div class="ppb_infodiv">
                        <div class="ppb_name-price">
                          <div class="ppb_name">
                            <div class="text-block-1420">6 Month Plan<br></div>
                            <div class="text-block-1410">Lock in 12 months of refills</div>
                          </div>
                          <div class="pbb_price">
                            <div class="pbb_priceflex">
                              <div class="text-block-1416">$</div>
                              <div class="text-block-1413">1149</div>
                              <div class="text-block-1416">.97</div>
                            </div>
                            <div class="text-block-1412">$191.66/mo</div>
                          </div>
                        </div>
                        <p class="paragraph-174">Pay up front for <strong>6 months</strong> and receive 12 months of refills.</p>
                        <ul role="list" class="list-5">
                          <li class="list-item-11">
                            <div class="text-block-1419">All Dosages Same Price.</div>
                          </li>
                          <li class="list-item-11">
                            <div class="text-block-1419">Doctor Visit Included.</div>
                          </li>
                          <li class="list-item-11">
                            <div class="text-block-1419">12 Months of Refills (provided ONLY by our pharmacy partner and after doctor checkin)</div>
                          </li>
                        </ul>
                      </div>
                      <div class="ppb_timer-buttondiv">
                        <a href="#" class="button-135 w-button">BUY NOW!</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </section>
    
  </div>
</template>

<script>
import NavSection from '../product/NavSection.vue';
import myNewSelfSection from './myNewSelfSection.vue';
import OrderInfoSection from './orderInfoSection.vue';
import ProfileSection from './profileSection.vue';
import prescriptionShow from './prescriptionShow.vue';
import talkToDocWindow from './talkToDocWindow.vue';
import {
  mapGetters
} from 'vuex';

export default {
name: 'HomePage',

components: {
  NavSection,
  myNewSelfSection,
  ProfileSection,
  OrderInfoSection,
  prescriptionShow,
  talkToDocWindow
},

props: ["stripeKey"],

data() {
  return {
    currentTab: 'orders', // Changed default tab to 'orders'
    baseUrl: process.env.VUE_APP_API_ENDPOINT
  }
},

computed: {
  ...mapGetters(['user', 'getLatestPrescription', 'getCase']),
      first_name() {
          try {
              return this.user.first_name;
          } catch (error) {
              console.log(error);
              return "";
          }
      },
    hasPrescription() {
        return Array.isArray(this.getLatestPrescription) && this.getLatestPrescription.length > 0;
    },
    hasCase(){
      return !!this.getCase && this.getCase.provider === 1 
    }
},

watch: {
  // Reset tab if prescription is removed and current tab is dosage
  hasPrescription(newValue) {
    if (!newValue && this.currentTab === 'dosage') {
      this.currentTab = 'orders';
    }
  }
},

methods: {
  switchTab(tabName) {
      this.currentTab = tabName;
      this.$store.dispatch('setActiveHomeTab', tabName);
            
  },
  
},

created() {
  window.scroll(0,0);
},

mounted() {
  
}
}
</script>
<style scoped>
.tabs-menu {
    grid-column-gap: 5px;
    grid-row-gap: 5px;
    background-color: var(--white);
    border-bottom: 1px #dfdfdf;
    border-radius: 11px;
    grid-template-rows: auto;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    grid-auto-columns: 1fr;
    padding-top: 10px;
    padding-bottom: 10px;
    display: grid;
}
@media (max-width: 768px) {
  .tabs-menu {
    grid-column-gap: 3px;
    grid-row-gap: 8px;
    padding: 8px 5px;
    
    /* Mobile: Stack in 2-3 columns depending on screen size */
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }
}
</style>